import React from 'react';

const IconCircleUnchecked = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 2.21002V2.22002M2.20996 5.5V5.51M1 10V10.01M2.20996 14.5V14.51M5.5 17.79V17.8M10 19V19.01M14.5 17.79V17.8M17.79 14.5V14.51M19 10V10.01M17.79 5.5V5.51M14.5 2.21002V2.22002M10 1V1.01" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IconCircleUnchecked;
